export default "__VITE_ASSET__b5c2dae9__"